import { type PropsWithChildren, type ReactElement } from 'react'
import * as S from './phone-number.styled'

export function PhoneNumber ({ children }: PropsWithChildren): ReactElement {
  return <S.Container>{children}</S.Container>
}
